import axios from "axios";

export const updateUser = async (request, env) => {
  // Enhanced security: only allow mock mode in development environments
  const allowMockDataDomains = ['localhost', '127.0.0.1', '192.168'];
  const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'true' &&
    process.env.NODE_ENV === 'development' &&
    allowMockDataDomains.some(domain => window.location.href.includes(domain));

  if (useMockData) {
    console.log('Mock mode: Skipping user update request:', request);
    return;
  }

  const apiUrl = window.location.href.includes("localhost")
    ? "http://localhost:8890/user-data"
    : "https://www.rebusmetod.com/user-data";

  try {
    !env?.isLF && await axios?.get(`${apiUrl}/${request}/`);
  } catch (error) {
    console.error('updateUser error:', error);

    // If we're in dev environment and API fails, just log it
    if (window.location.href.includes("localhost")) {
      console.warn('Local API unavailable, skipping user update for:', request);
    }
  }
};
